<template>
    <viewer-tab :title="title" v-show="show" :icon="icon" :url-help="urlHelp" :click-x="clickX">
        <el-button slot="header-buttons" class="menu-icon-btn" type="text" @click="handlePrint">
            <i class="el-icon-printer"/>
        </el-button>
        <div class="report-wrapper">
            <div class="content" ref="content">
                <div class="header">
                    <!--COMPANY, PREPARED BY, PREPARED ON-->
                    <h2 id="company">
                        <img :src="company.logo" height="40" alt=""/>
                        {{ company.name }}
                    </h2>
                    <div class="section">
                        <table id="company-table">
                            <tr>
                                <td>Prepared by:</td>
                                <td>{{ getUserFullName() }}</td>
                            </tr>
                            <tr>
                                <td>Prepared on:</td>
                                <td>{{ Date() }}</td>
                            </tr>
                        </table>
                    </div>

                    <!--GEARS APP, MODEL INFO, RELEASE INFO-->
                    <h3 id="dh-app">
                        <!--img is better than svg for printing-->
                        <!--<dh-logo size="20pt" color-gear="var(&#45;&#45;color)" style="padding-right: .2em"></dh-logo>-->
                        <img :src="$urls.DH_LOGO_128" height="24" alt=""/>
                        Gears App - {{ title }}
                    </h3>
                    <div class="section">
                        <!--PLACEHOLDER {feature} model screenshot to the right of table-->
                        <table id="model-table">
                            <tr>
                                <td>Name:</td>
                                <td>{{ master.name }}</td>
                            </tr>
                            <tr>
                                <td>Number:</td>
                                <td>{{ master.number }}</td>
                            </tr>
                            <tr>
                                <td>Description:</td>
                                <td>{{ master.description }}</td>
                            </tr>
                            <tr>
                                <td>Created:</td>
                                <td>{{ formatDatetime(model.createdOn) }} by {{ getUserFullName(model.createdBy) }}</td>
                            </tr>
                            <tr>
                                <td>Last modified:</td>
                                <td>{{ formatDatetime(model.lastModifiedOn) }} by {{ getUserFullName(model.lastModifiedBy) }}</td>
                            </tr>
                        </table>

                        <h4>Releases</h4>
                        <table v-if="releases.length === 0" id="no-releases">
                            <tr>
                                <td>No model releases.</td>
                            </tr>
                        </table>
                        <table v-else id="release-table">
                            <tr>
                                <th>Ver.</th>
                                <th>Modified on</th>
                                <th>Modified by</th>
                                <th>Notes</th>
                                <th>Lock</th>
                            </tr>
                            <!--#fffad5-->
                            <!--() => {if(i===1) return {'backgroundColor': '#fffad5'}}-->
                            <tr v-for="(release, i) in releases" :key="i" :style="highlightRow(release.version)">
                                <td style="text-align: center">{{ release.version }}</td>
                                <td>{{ formatDatetime(release.lastModifiedOn) }}</td>
                                <td>{{ getUserFullName(release.lastModifiedBy) }}</td>
                                <td style="min-width: 100px; max-width: 300px;">{{ release.notes }}</td>
                                <td style="text-align: center">
                                    <span v-if="release.lock">Yes</span>
                                    <span v-else>No</span>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <hr>
                <div class="body">
                    <slot/>
                </div>
                <!--PLACEHOLDER {feature} report footer-->
                <!-- ~ Add to footer of each print page, if possible-->
                <!-- ~ Company logo + name, model name, page number-->
            </div>
            <el-backtop target=".content" :bottom="50" :right="40"/>
        </div>
    </viewer-tab>
</template>

<script>
  import ButtonGroupHeader from "../_buttons/ButtonGroupHeader";
  import ReportTableParams from "./ReportTableParams";
  import { printElement } from "../../assets/js/utils";
  import { mapState, mapGetters } from "vuex";
  import ViewerTab from "../viewer/ViewerTab";

  export default {
    name: "ReportTab",
    components: {ViewerTab, ReportTableParams, ButtonGroupHeader},
    props: {
      name: String,  // unique tab name
      icon: String,
      title: String,
      urlHelp: String,
      clickX: Function,
      loading: Boolean,
    },

    computed: {
      ...mapGetters({
        getUser: 'getUser',
        getUserFullName: 'getUserFullName',
      }),
      ...mapState({
        company: state => state.session.user.organization,
        model: state => state.model.doc,
        master: state => state.model.master,
        releases: state => state.model.releases,
      }),
    },
    data() {
      return {
        show: false,
      }
    },
    watch: {
      loading(val) {
        // watch loading prevents report tab from opening until loading prop is true
        if (!val) {
          // cancel loading spinner and trigger transition
          this.$store.commit('LOADING_VIEWER', false);
          this.show = true;
        }
      },
    },

    methods: {
      highlightRow(version) {
        if (this.model.version === version) {
          return {backgroundColor: '#fffad5'};
        }
      },
      handleClose() {
        // trigger transition
        this.show = false;

        // timeout to allow time for transition
        setTimeout(() => {
          this.clickX()
        }, 100);
      },
      handlePrint() {
        let elem = this.$refs.content;
        printElement(elem);
      },
      formatDatetime(val) {
        return this.$handlers.lib.localeDatetime(val);
      },
    },
  }
</script>

<style scoped lang="scss" src="./assets/report-tab.scss"/>
<style scoped lang="scss" src="../../assets/css/table.scss"/>
